import type { Order, OrderContractElement } from '@hero/schema';

/**
 * Picks the contract leg whose price drives reorder preview + lock
 * decisions. Prefers the viewer's leg; falls back to the first leg
 * with a positive load price, then `contracts[0]`.
 *
 * Role-neutral — no carrier/customer first/last-leg split.
 */
export function resolveReorderSourceLeg(
  order: Order,
  viewerLeg?: OrderContractElement,
): OrderContractElement | undefined {
  if (viewerLeg) return viewerLeg;

  const contracts = order.contracts ?? [];
  if (contracts.length === 0) return undefined;

  const withPrice = contracts.find(
    leg => (leg.amount?.itemsOriginalSubtotal ?? 0) > 0,
  );
  return withPrice ?? contracts[0];
}
